import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <CommentsSection />
        <ContactSection />
        <AppSection />
        <TopicsSection />
        <FeaturesSection />
        <RankingSection />
        <CarouselSection />
        <UpdatesSection />
        <IndexSection />
        <CardsSection />
        <MediaSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}